import { collection, doc, getDoc, getDocs, limit, query, where } from "firebase/firestore";

function phoneCandidates(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return [];

  const withoutCountry = digits.startsWith("91") && digits.length > 10 ? digits.slice(2) : digits;
  return [...new Set([digits, withoutCountry, `91${withoutCountry}`].filter(Boolean))];
}

async function firstProfileByField(db, field, value) {
  if (!value) return null;

  const snapshot = await getDocs(query(collection(db, "profiles"), where(field, "==", value), limit(1)));
  if (snapshot.empty) return null;

  const profileDoc = snapshot.docs[0];
  return normalizeProfile({ id: profileDoc.id, ...profileDoc.data() });
}

export function getProfileImages(profile) {
  if (!profile) return [];

  const imageSources = [
    profile.imageUrls,
    profile.images,
    profile.photos,
    profile.photoUrls,
    profile.imageUrl,
    profile.photoURL,
    profile.photoUrl,
    profile.profilePhoto,
    profile.profilePhotoUrl,
    profile.profileImage,
    profile.profileImageUrl,
  ];

  return imageSources
    .flatMap((source) => {
      if (!source) return [];
      if (Array.isArray(source)) return source;
      return [source];
    })
    .map((item) => {
      if (typeof item === "string") return item;
      return item.url || item.downloadURL || item.src || "";
    })
    .filter(Boolean);
}

function normalizeProfile(profile) {
  if (!profile) return null;
  return {
    ...profile,
    imageUrls: getProfileImages(profile),
  };
}

export async function findProfileForUser(db, user, phone) {
  if (!user?.uid) return null;

  const directSnapshot = await getDoc(doc(db, "profiles", user.uid));
  if (directSnapshot.exists()) {
    return normalizeProfile({ id: directSnapshot.id, ...directSnapshot.data() });
  }

  const fieldLookups = [
    ["uid", user.uid],
    ["profileId", user.uid],
    ["userId", user.uid],
    ["authUid", user.uid],
  ];

  for (const [field, value] of fieldLookups) {
    const profile = await firstProfileByField(db, field, value);
    if (profile) return profile;
  }

  for (const candidate of phoneCandidates(phone || user.phoneNumber)) {
    const profile =
      (await firstProfileByField(db, "mobileNumber", candidate)) ||
      (await firstProfileByField(db, "phone", candidate));
    if (profile) return profile;
  }

  return null;
}
